import { LoadingOutlined } from "@ant-design/icons";
import { Pagination } from "antd";
import { connect } from "react-redux";

import styles from "./style.module.scss";

const mapDispatchToProps = {};

const getListColumns = (isAdmin) => {
  const columns = [
    {
      title: "NAME",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "CREATED AT",
      key: "createdAt",
      dataIndex: "createdAt",
    },
    {
      title: "ADMIN",
      key: "admin",
      dataIndex: "admin",
    },
    {
      title: "USER",
      key: "user",
      dataIndex: "user",
    },
    {
      title: "REVIEWER",
      key: "reviewer",
      dataIndex: "reviewer",
    },
  ];

  if (!isAdmin) {
    columns.push({
      title: "ACTIONS",
      key: "actions",
      dataIndex: "actions",
    });
  }

  return columns;
};

const OrganizationList = ({
  totalCount,
  activePage,
  pageSize,
  organizationRows,
  loading,
  handlePageChange,
  isAdmin,
}) => {
  return (
    <>
      <div className={styles.container}>
        {loading ? (
          <LoadingOutlined style={{ fontSize: 30, align: "center", display: "inline-flex" }} spin />
        ) : (
          <div className={styles.tableContainer}>
            <div className={styles.table}>
              <div className={styles.header}>
                {getListColumns(isAdmin).map((column, index) => (
                  <div key={index} className={styles.columnHeader}>
                    {column.title}
                  </div>
                ))}
              </div>
              <div className={styles.rowContainer}>
                {organizationRows.map((row, rowIndex) => (
                  <div key={rowIndex} className={styles.row}>
                    {getListColumns(isAdmin).map((column, colIndex) => (
                      <div key={colIndex} className={styles.cell}>
                        {row[column.dataIndex]}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      <Pagination
        showSizeChanger={false}
        className={styles.pagination}
        current={activePage}
        pageSize={pageSize}
        onChange={handlePageChange}
        total={totalCount}
      />
    </>
  );
};

export default connect((/*state*/) => ({}), mapDispatchToProps)(OrganizationList);
